import { render, staticRenderFns } from "./SpaceAnalysis.vue?vue&type=template&id=58864996&"
import script from "./SpaceAnalysis.vue?vue&type=script&lang=js&"
export * from "./SpaceAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard,QCardSection})
